import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ae-professional-liability',
  templateUrl: './professional-liability.component.html',
  styleUrls: ['./professional-liability.component.scss']
})
export class ProfessionalLiabilityComponent implements OnInit {
  summaryPanel;
  get summaryAPIData() {
    return this.summaryPanel;
  }
  @Input() set summaryAPIData(value) {
    this.summaryPanel = { ...value };
  }
  @Input() summarySitecoreData;
  @Input() pageName;
  summaryContent;
  constructor() {}

  ngOnInit(): void {
    this.summaryContent = this.summarySitecoreData;
    window.scrollTo(0, 0);
  }
}
